"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Li", {
  enumerable: true,
  get: function get() {
    return _li["default"];
  }
});
exports["default"] = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _listModule = _interopRequireDefault(require("./list.module.less"));

var _li = _interopRequireWildcard(require("./li"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var List = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      component = _ref.component,
      _ref$ordered = _ref.ordered,
      ordered = _ref$ordered === void 0 ? false : _ref$ordered,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 2 : _ref$spacing,
      otherProps = _objectWithoutProperties(_ref, ["children", "className", "component", "ordered", "spacing"]);

  var Component = component || (ordered ? 'ol' : 'ul');
  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: (0, _classnames["default"])(className, _listModule["default"].list, Component === 'ol' && _listModule["default"]['list--ordered'], Component === 'ul' && _listModule["default"]['list--unordered']),
    ref: ref
  }, otherProps), /*#__PURE__*/_react["default"].createElement(_li.ListSpacingContext.Provider, {
    value: spacing
  }, children));
});

List.displayName = 'List';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  var PropTypes = require('prop-types');

  List.propTypes = {
    /** Creates a ordered, numbered list. */
    ordered: PropTypes.bool,

    /** Controls spacing between list elements (NDS value) */
    spacing: PropTypes.oneOfType([PropTypes.oneOf([0, 1, 2, 3, 4, 5]), PropTypes.oneOf(['0', '1', '2', '3', '3-half', '4', '5'])]),

    /**
     * Allows you to provide a React component or other HTML element,
     * overriding the default `ul` and `ol` options.
     */
    component: PropTypes.elementType,

    /** Children inside the <ul> or <ol>. Should be <Li> elements. */
    children: PropTypes.node,
    className: PropTypes.string
  };
}

var _default = List;
exports["default"] = _default;